document.addEventListener('DOMContentLoaded', function () {

  const DECARB = 0.9;

  // Cannabinoid Calculator
  document.querySelector('.js-calc-cannabinoid').addEventListener('click', function (evt) {
    const thca = parseFloat(document.querySelector('.js-thca').value);
    const cbda = parseFloat(document.querySelector('.js-cbda').value);
    const weight = parseFloat(document.querySelector('.js-flower-weight').value);

    if (isNaN(thca) || thca < 0) { alert(window.edibleCalcStrings.thca_error); return; }
    if (isNaN(cbda) || cbda < 0) { alert(window.edibleCalcStrings.cbda_error);; return; }
    if (isNaN(weight) || weight <= 0) { alert(window.edibleCalcStrings.weight_error); return; }

    const totalTHCA = weight * 1000 * (thca/100);
    const totalCBDA = weight * 1000 * (cbda/100);
    const totalTHC = totalTHCA * DECARB;
    const totalCBD = totalCBDA * DECARB;

    document.querySelector('.js-total-thca').textContent = totalTHCA.toFixed(1);
    document.querySelector('.js-total-thc').textContent = totalTHC.toFixed(1);
    document.querySelector('.js-total-cbda').textContent = totalCBDA.toFixed(1);
    document.querySelector('.js-total-cbd').textContent = totalCBD.toFixed(1);

    document.querySelector('.js-cannabinoid-results').hidden = false;
    document.querySelector('.omnisend_wrapper').style.display = 'block';
    const rawText = document.querySelector('.js-cannabinoid-results .results-list').innerText;
    const formatted = rawText
  .split('\n')
  .map(line => line.trim())
  .filter(line => line.length > 0)
  .map(line => line.replace(':', ': '))
  .join(' | ');
  console.log(formatted)
    document.querySelector('.omnisend_wrapper input[name="custom_cannabinoids_edibles"]').value = formatted;
  });

  // Base Ingredient Potency Calculator
  document.querySelector('.js-calc-base').addEventListener('click', function () {
    const thca = parseFloat(document.querySelector('.js-thca-base').value);
    const cbda = parseFloat(document.querySelector('.js-cbda-base').value);
    const weight = parseFloat(document.querySelector('.js-flower-weight-base').value);
    const volume = parseFloat(document.querySelector('.js-base-volume').value);

    if (isNaN(thca) || thca < 0) { alert(window.edibleCalcStrings.thca_error); return; }
    if (isNaN(cbda) || cbda < 0) { alert(window.edibleCalcStrings.cbda_error); return; }
    if (isNaN(weight) || weight <= 0) { alert(window.edibleCalcStrings.weight_error); return; }
    if (isNaN(volume) || volume <= 0) { alert(window.edibleCalcStrings.volume_error); return; }

    // Step 1: Total cannabinoids
    const totalTHCA = weight * 1000 * (thca/100);
    const totalCBDA = weight * 1000 * (cbda/100);

    // Step 2: Decarb
    const totalTHC = totalTHCA * DECARB;
    const totalCBD = totalCBDA * DECARB;

    // Step 3: Potency per g/ml
    const thcPerGml = totalTHC / volume;
    const cbdPerGml = totalCBD / volume;

    const thcPercentBase = thcPerGml / 10;
    const cbdPercentBase = cbdPerGml / 10;

    document.querySelector('.js-total-thca-base-result').textContent = totalTHCA.toFixed(1);
    document.querySelector('.js-total-thc-base-result').textContent = totalTHC.toFixed(1);
    document.querySelector('.js-total-cbda-base-result').textContent = totalCBDA.toFixed(1);
    document.querySelector('.js-total-cbd-base-result').textContent = totalCBD.toFixed(1);

    document.querySelector('.js-thc-mg').textContent = thcPerGml.toFixed(1);
    document.querySelector('.js-cbd-mg').textContent = cbdPerGml.toFixed(1);
    document.querySelector('.js-thc-percent').textContent = thcPercentBase.toFixed(2);
    document.querySelector('.js-cbd-percent').textContent = cbdPercentBase.toFixed(2);

    document.querySelector('.js-base-results').hidden = false;
    document.querySelector('.omnisend_wrapper__1').style.display = 'block';
  const lists = document.querySelectorAll('.js-base-results .results-list');

let finalText = '';

lists.forEach(list => {
  const items = list.querySelectorAll('li');

  items.forEach(li => {
    const label = li.childNodes[0].textContent.trim().replace(':', '');

    const strong = li.querySelector('strong')?.innerText.trim() || '';

    // Get percentage safely (like 4.50%)
    const percentEl = li.querySelector('.js-thc-percent, .js-cbd-percent');
    const percent = percentEl ? percentEl.innerText.trim() : '';

    if (percent) {
      finalText += `${label}: ${strong} (${percent}%) | `;
    } else {
      finalText += `${label}: ${strong} | `;
    }
  });
});

// remove last " | "
finalText = finalText.replace(/\s\|\s$/, '');
    document.querySelector('.omnisend_wrapper__1 input[name="custom_thccbd"]').value = finalText;
  });

});